module.exports = __webpack_public_path__ + "assets/3191184c92e346edefedd51f200a5ace.png";